import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PickupPointUtil from '../../../../util/PickupPointUtil';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useDeliveryState } from '../../../../context/CheckoutDeliveryContext';
import { DeliverySelectedLocation } from '../DeliverySelectedLocation';
import { StackBlock, TextAlpha } from '@yonderland/andes-react';
import { sortOpeningHours } from './PickupPoint';
import { OpeningHours } from '../../../opening-hours/OpeningHours';
export const PickupPointSelected = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [{ pickupPoint }, dispatch] = useDeliveryState();
    const { selectedPickupPoint } = pickupPoint;
    if (!selectedPickupPoint)
        return null;
    const locationName = selectedPickupPoint.locationName;
    const address = selectedPickupPoint.address;
    const houseNumber = selectedPickupPoint.houseNumber;
    const postcode = selectedPickupPoint.postcode;
    const city = selectedPickupPoint.city;
    const organisationName = `${selectedPickupPoint.organisationName} ${PickupPointUtil.getTranslation(selectedPickupPoint.sanitizedLocationType, selectedPickupPoint.locationType, t)}`;
    const openingHours = selectedPickupPoint.openingHours;
    const isAlwaysOpen = PickupPointUtil.isAlwaysOpen(selectedPickupPoint.sanitizedLocationType || selectedPickupPoint.locationType);
    const handleEditPickupPoint = () => {
        dispatch({ type: 'set_open_selector', payload: 'pickup-point' });
    };
    const getOpeningHours = () => {
        if (!openingHours) {
            return null;
        }
        return isAlwaysOpen ? (_jsx(TextAlpha, { children: t('checkout.delivery.pickuppoint.open.24') })) : (_jsxs(StackBlock, { gap: "1", children: [_jsx(TextAlpha, { strong: true, children: t('checkout.delivery.pickuppoint.openinghours.week') }), _jsx(OpeningHours, { openingHours: sortOpeningHours(openingHours) })] }));
    };
    const getAddress = () => (_jsxs(_Fragment, { children: [organisationName, _jsx("br", {}), address, " ", houseNumber, _jsx("br", {}), postcode, " ", city] }));
    return (_jsx(DeliverySelectedLocation, { locationName: locationName, addressContent: getAddress(), openingHoursContent: getOpeningHours(), handleEdit: handleEditPickupPoint }));
};
